import { ticketUpdateDescription as description } from './description';
import { updateTicket as execute } from './execute';

export { description, execute };
